import React from 'react'
import {
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  TextField,
  Tooltip,
} from '@mui/material'
import { withStyles } from 'tss-react/mui'
import { ClearIcon } from 'icons'

import styles from './EditTextField.style'

interface Props {
  classes: Record<string, string>,
  input: Record<string, any>,
  meta: {
    error?: string,
    touched?: boolean,
  },
  resetField: (...args: any[]) => void,
  hint?: string | null,
}

class EditTextField extends React.PureComponent<Props> {
  static defaultProps = {
    hint: null,
  }

  createAdorment =() => {
    const {
      resetField,
      classes,
    } = this.props
    return (
      <InputAdornment position="start">
        <IconButton onClick={resetField} aria-label="Delete" size="large">
          <ClearIcon className={classes.icon} />
        </IconButton>
      </InputAdornment>
    )
  }

  createTextField =() => {
    const {
      input,
    } = this.props
    return (
      <TextField
        variant="standard"
        onChange={((event: any, index: any, value: any) => input.onChange(value)) as any}
        InputProps={{
          endAdornment: this.createAdorment(),
          ...input,
        }}
      />
    )
  }

  hintControl =() => {
    const {
      hint,
    } = this.props
    if (hint) {
      return (
        <Tooltip title={hint}>{this.createTextField()}</Tooltip>
      )
    }
    return (
      this.createTextField()
    )
  }

  render() {
    const {
      meta: { touched, error },
      classes,
    } = this.props
    return (
      <FormControl variant="standard" className={classes.input}>
        {this.hintControl()}
        {touched && error && (
          <FormHelperText id="component-error-text" className={classes.text}>
            {error}
          </FormHelperText>
        )}
      </FormControl>
    )
  }
}

export default withStyles(EditTextField, styles as any) as unknown as React.ComponentType<Omit<Props, 'classes'>>
